/**
 * Configuración de bodies.
 * Define offsets especiales para ciertos bodies (ej: talkOffset para textos de diálogo).
 */

export interface BodyConfigEntry {
  talkOffset?: number; // Offset Y adicional para el texto de habla (negativo = más arriba)
}

export interface BodyConfig {
  defaultTalkOffset: number;
  bodies: Record<string, BodyConfigEntry>;
}

/**
 * Configuración de offsets para bodies.
 * - defaultTalkOffset: offset Y por defecto para el texto de habla (desde arriba del sprite)
 * - bodies: configuración específica por bodyId
 * 
 * Los valores negativos mueven el texto más arriba.
 * El texto se posiciona en: sprite.y - spriteHeight + talkOffset
 * Entonces talkOffset = 0 pone el texto en la parte superior del sprite.
 * Valores negativos lo mueven más arriba.
 */
const bodyConfig: BodyConfig = {
  defaultTalkOffset: 0, // Negativo = texto más arriba del sprite (cambiado de -8 a -11 para mover 3px más arriba)
  bodies: {
    // Puedes agregar bodies específicos si necesitan un offset diferente
    // '13': { talkOffset: -10 }
  }
};

/**
 * Obtiene el offset de texto de habla para un body específico.
 * @param bodyId ID del body
 * @returns Offset Y para el texto de habla (negativo = más arriba del sprite)
 */
export function getTalkOffset(bodyId: number): number {
  const entry = bodyConfig.bodies[String(bodyId)];
  if (entry?.talkOffset !== undefined) {
    return entry.talkOffset;
  }
  return bodyConfig.defaultTalkOffset;
}

export default bodyConfig;
